<template>
<div id="index">
  <p v-if="Landing">正在登录中……</p>
  <div  id="runTaskDiv" v-html="errorInfo">
  </div>
  <input id="hiddenContent" ref="hiddenContent" v-model="hiddenContent" type="text" v-if="false" />
</div>
</template>
<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import { loadScript } from '@/assets/js/utils'


export default {
  data () {
    return {
      Landing:true,
      webConfigInfo:{},
      paramInfo:{},
      yellowPage:"",
      footerColumnInfos:[],
      warehousingUrl:"",
      navigationColumnInfos:[],
      hitSearchUrl:'',
      enterpriseResourceBaseUrl:'',
      yellowPageColumn:{},
      productAndSolutionColumn:{},
      loading:true,
      runRecuritUrl:'',
      noticeInfo:[],
      showMessage:'',
      loginFlag:false,
      userInfo:{},
      companyInfo:{},
      messageNumber:'',
      redirectUrl:'',
      responseInfo:{},
      showFlag:false,
      hiddenContent:'',
      currentResponseInfo:{},
      email:'',
      mobile:'',
      hiddenTrueName:'',
      hiddenEmail:'',
      hiddenMobile:'',
      currentUserInfo:{},
      errorInfo:'',
      password:"",
      userName:"",
      rememeberPassword:false,
      checkFlag:false,
      accountInfo:{},
      rememberInfo:{},
      loginUser:'',
      loginPass:'',
      regeisterType:'',
      checkCardInfo:{},
      userTag:'',
      isCompanyManager:false,
      verrifyCodeUrl:'',
      verifyCode:'',
      verifyCodeExt:'',
      checkVerifyFlag:false,
      loginFailNumber:0,
      openId:'',
      coordinationSupplierAuthFlag:false,
      coordinationSystemAuthFlag:false,
      supplierManagerAuthFlag:false
    }
  },
  computed: mapState([
    'KP'
  ]),
  mounted() {
    loadScript('https://oapi.fosun.com/js/fosun_oapi_login-2.0.0_v6.js',() => {
      loadScript('http://o.fosun.com/mobile_portal/fosun/server/return.js',() => {
        try {
            fosun_oapi_login.getDDAccount(function(user){
              let reg = new RegExp("(^|&)redirectURL=([^&]*)(&|$)", "i");
              let redirectUrl = `${window.location.origin}/dingWorkbench`;
              if(window.location.search != ""){
                redirectUrl = window.location.search.split("?")[1];
                redirectUrl = redirectUrl.replace("redirectURL=","");
              }else{
                redirectUrl = `${window.location.origin}/dingWorkbench`;
              }

              window.location.href='/fosunCmsLoginExt?fullname='+user.fullname+"&email="+user.email+'&mobile='+user.mobile1+'&dingCode='+user.dd_id+'&redirectURL='+encodeURI(redirectUrl);
            });
          } catch (e) {
            throw e
          }
      });
    });
  },
  created () {


  },
  updated(){
    this.Landing=false;
  },
  methods:{
    jump(url){
      window.location.href = url;
    }
  }
}
</script>

<style scoped lang="stylus">
@media only screen and (max-width: 766px)
  .games
    display: none
</style>



// WEBPACK FOOTER //
// src/pages/fosunCmsLogin/index.vue